module.exports = __webpack_public_path__ + "img/fullsize.b7e5bee1.svg";